import React, { useState } from 'react';
import '../css/Dashboard.css';

const Rightbar = () => {
    return (
        <div className="rightbar">
            <div className="title">Shortcuts</div>
            <ul>
                <li>
                    <a href="#">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M10 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-8l-2-2z"></path>
                        </svg>
                        New Mail
                    </a>
                </li>
                <li>
                    <a href="#">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M4 4h16v16H4z"></path> {/* Outer box for inbox */}
                            <path d="M22 6l-10 7L2 6"></path> {/* Envelope line */}
                        </svg>
                        Mail Inbox
                    </a>
                </li>

                <li>
                    <a href="#">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M4 4h16v16H4z"></path> {/* Outer box for inbox */}
                            <path d="M22 6l-10 7L2 6"></path> {/* Envelope line */}
                            <path d="M16 18l6-6"></path> {/* Paper plane for sent mail */}
                            <path d="M10 12l6-6"></path> {/* Paper plane line */}
                        </svg>
                        Sent Mail
                    </a>
                </li>

                <li>
                    <a href="#">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M4 4h16v16H4z"></path> {/* Outer box for inbox */}
                            <path d="M22 6l-10 7L2 6"></path> {/* Envelope flap */}
                            <path d="M3 6h18v12H3z"></path> {/* Envelope body */}
                            <path d="M16 11l2-2"></path> {/* Pencil for draft */}
                            <path d="M18 9l2-2"></path> {/* Pencil line for draft */}
                        </svg>
                        Draft Mail
                    </a>
                </li>

                <li>
                    <a href="#">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z"></path> {/* Outer box for the document */}
                            <path d="M14 2v6h6"></path> {/* Top right corner of the document */}
                            <path d="M10 12h4"></path> {/* Horizontal line in document */}
                            <path d="M10 16h4"></path> {/* Another horizontal line for register */}
                        </svg>
                        Document Register
                    </a>
                </li>

                <li>
                    <a href="#">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z"></path> {/* Outer document shape */}
                            <path d="M10 12h4"></path> {/* Horizontal line representing text */}
                            <path d="M10 16h4"></path> {/* Another horizontal line */}
                            <path d="M12 8v4"></path> {/* Vertical line representing the upload arrow */}
                            <path d="M10 10l2-2 2 2"></path> {/* Upward arrow for upload */}
                        </svg>
                        Multiple File Upload
                    </a>
                </li>

            </ul>
        </div>
    );
};

export default Rightbar;
